import { useState } from "react";

const navItems = ["About", "TGPT", "Sona", "Research", "Staking", "AI Market"];

export default function Navbar() {
  const [active, setActive] = useState("About");

  return (
    <header className="relative z-20 w-full px-8 md:px-12 pt-6">
      <nav className="flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-apps-2-fill text-2xl text-neutral-900"></i>
          </div>
          <span className="text-xl font-semibold tracking-tight text-neutral-900">
            TARS
          </span>
        </a>

        {/* Center nav */}
        <div className="hidden md:flex items-center gap-1 bg-neutral-100/80 backdrop-blur-sm rounded-full px-2 py-2 border border-neutral-200/60">
          {navItems.map((item) => (
            <a
              key={item}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setActive(item);
              }}
              className={`px-4 py-1.5 text-sm rounded-full whitespace-nowrap cursor-pointer transition-colors ${
                active === item
                  ? "bg-white text-neutral-900 shadow-sm"
                  : "text-neutral-600 hover:text-neutral-900"
              }`}
            >
              {item}
            </a>
          ))}
        </div>

        {/* Connect Wallet button */}
        <button className="flex items-center gap-2 bg-neutral-900 text-white text-sm px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-neutral-800 transition-colors">
          <span>Connect Wallet</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-link text-sm"></i>
          </div>
        </button>
      </nav>
    </header>
  );
}